import { defineMessages } from 'react-intl';

export default defineMessages({
    deactivateTitle1: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Title 1',
        defaultMessage: 'At least one of your existing payment methods has been automatically deleted.'
    },
    deactivateTitle2_1: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Title 2.1',
        defaultMessage: 'Please visit the'
    },
    deactivateTitle2_2: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Title 2.2',
        defaultMessage: 'Manage Payment Methods'
    },
    deactivateTitle2_3: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Title 2.3',
        defaultMessage: 'screen to view this payment method and take necessary actions.'
    },
    deactivateBodyHeader: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body Header',
        defaultMessage: 'Please note:'
    },
    deactivateBody1_1: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 1.1',
        defaultMessage: 'Auto Pay will stop immediately'
    },
    deactivateBody1_2: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 1.2',
        defaultMessage: 'for all policies on your account that were linked to this payment method'
    },
    deactivateBody2_1: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 2.1',
        defaultMessage: 'To restart Auto Pay'
    },
    deactivateBody2_2: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 2.2',
        defaultMessage: 'each policy must be re-enrolled individually'
    },
    deactivateBody3_1: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 3.1',
        defaultMessage: 'For '
    },
    deactivateBody3_2: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 3.2',
        defaultMessage: '10-Pay plans,'
    },
    deactivateBody3_3: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 3.3',
        defaultMessage: 'Auto Pay must be active'
    },
    deactivateBody3_4: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 3.4',
        defaultMessage: 'before the next invoice billed date'
    },
    deactivateBody4_1: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 4.1',
        defaultMessage: 'You may continue using the same card or bank account by'
    },
    deactivateBody4_2: {
        id: 'twia.managepaymentmethods.Autodeactivate Popup Body 4.2',
        defaultMessage: 'adding it again as a new payment method'
    },
    accept: {
        id: 'twia.managepaymentmethods.Autodeactivate Accept',
        defaultMessage: 'Accept'
    }
});
